import { useContext } from 'react';
import { BuySellAdjustmentTableContext, IBuySellAdjustmentTableContext } from './BuySellAdjustmentTableContext';

export const useClientDetailsTable = () => useContext<IBuySellAdjustmentTableContext>(BuySellAdjustmentTableContext);
